import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/incidencias-tipos-de-nominas-empleados';

/**
 * GET Incidencias Tipos de Nominas Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasTiposDeNominasEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia Tipo de Nomina Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaTipoDeNominaEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencia Tipo de Nomina Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaTipoDeNominaEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencia Tipo de Nomina Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaTipoDeNominaEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencia Tipo de Nomina Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaTipoDeNominaEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
